import { t } from "i18next";
import { Copy, Ban, Eye } from "lucide-react";

import { RowActionsMenu } from "@/core/components/shared/data-table";
import { notifSilence, notifSilenceError } from "@/core/utils/func/notifApp";
import type { QrCodeRow } from "@/features/merchant/components/qr-codes/qr-codes-columns";

/**
 * Menu d'actions de ligne pour un QR code : prévisualisation, copie du
 * jeton, révocation (branchée via callback ouvrant la dialog motif).
 */
export function QrCodeRowActions({
  qr,
  onPreview,
  onRevoke,
}: {
  qr: QrCodeRow;
  onPreview: (qr: QrCodeRow) => void;
  onRevoke: (qr: QrCodeRow) => void;
}) {
  const copyToken = async () => {
    if (!qr.payloadToken) return;
    try {
      await navigator.clipboard.writeText(qr.payloadToken);
      notifSilence(t("common.copied"));
    } catch {
      notifSilenceError(t("error"));
    }
  };

  return (
    <RowActionsMenu
      actions={[
        {
          id: "preview",
          label: t("merchant.qrCodes.actions.preview"),
          icon: Eye,
          onClick: () => onPreview(qr),
        },
        {
          id: "copy-token",
          label: t("merchant.qrCodes.actions.copyToken"),
          icon: Copy,
          onClick: copyToken,
        },
        ...(qr.status === "ACTIVE"
          ? [
              {
                id: "revoke",
                label: t("merchant.qrCodes.actions.revoke"),
                icon: Ban,
                variant: "destructive" as const,
                onClick: () => onRevoke(qr),
              },
            ]
          : []),
      ]}
    />
  );
}
